import marked from "marked";
import DOMPurify from "dompurify";

marked.setOptions({ breaks: true });

export default {
  methods: {
    parseMarkdown(md) {
      return DOMPurify.sanitize(marked(md));
    },
  },
};
